<p class="info-box-square my-2 p-3">
  <span class="icon-holder" *ngIf="iconClasses && !hideIcon">
    <i [class]="iconClasses"></i>
  </span>
  <span *transloco="let t">
    {{translationKey ? t(translationKey) : text}}
  </span>
</p>
